
import { z } from "zod";

// Define schema for the questions form
export const questionsFormSchema = z.object({
  questions: z.array(
    z.object({
      question: z.string().min(1, { message: "Question cannot be empty" }),
      explanation: z.string().optional(),
      isRequired: z.boolean().default(false)
    })
  ).default([{ question: "", explanation: "", isRequired: false }])
});

// Define type for the form values
export type QuestionsFormValues = z.infer<typeof questionsFormSchema>;

// Default values for questions to include explanation
export const questionsDefaultValues: QuestionsFormValues = {
  questions: [
    { question: "", explanation: "", isRequired: false }
  ]
};
